import { MuiAlertSnackbar, SnackbarState } from '.';
import { SnackbarContext } from './context';
import { useSnackbarAlert } from './use-snackbar-alert';

export const SnackbarContextProvider = ({ children, initialState }: { children: React.ReactNode; initialState?: Partial<SnackbarState> }) => {
	const [snackbar, setSnackbar] = useSnackbarAlert(initialState);
	const closeSnackbar = () => {
		setSnackbar({ open: false });
	};
	return (
		<SnackbarContext.Provider value={{ snackbar, setSnackbar, closeSnackbar }}>
			{children}
			<MuiAlertSnackbar {...snackbar} onClose={closeSnackbar} />
		</SnackbarContext.Provider>
	);
};
